import { useMemo } from 'react';

import { Box } from '@mui/material';

import { CustomCampaignSteps } from 'domains/campaigns/components/CustomCampaign/CustomCampaign';
import GraphNodeBlock from 'domains/campaigns/components/CustomCampaign/GraphCampaignNavigation/GraphNodeBlock';
import { Campaign } from 'domains/campaigns/types';
import buildCampaignGraph from 'domains/campaigns/utils/buildCampaignGraph';

export type Props = {
    campaign: Campaign;
    isPreviewOpen: boolean;
};

const GraphCampaignDetailsNavigation = ({ campaign, isPreviewOpen }: Props) => {
    const graph = useMemo(() => buildCampaignGraph(campaign.sends, undefined, campaign.abTestConfig), [
        campaign.sends,
        campaign.abTestConfig,
    ]);

    return (
        <Box
            data-testid="graph-campaign-details-navigation"
            role="navigation"
            aria-label="campaign workflow overview"
            display={isPreviewOpen ? 'none' : 'block'}
            ml={3}
            height="100%"
            width="75%"
        >
            {graph.nodes.map((node) => (
                <GraphNodeBlock
                    key={node.id}
                    node={node}
                    activeSendIndex={0}
                    activeStep={CustomCampaignSteps.NAME_CAMPAIGN}
                    readonly={true}
                />
            ))}
        </Box>
    );
};

export default GraphCampaignDetailsNavigation;
